// extracted by mini-css-extract-plugin
export default {"mainContainer":"Summary_mainContainer__GjM0z","photo":"Summary_photo__YoyoE","location":"Summary_location__tBgIn"};